import { useClientPrincipal } from "../context/ClientPrincipalContext";
import { useMemo } from "../imports";

export const useUserId = () => {
  const { clientPrincipal } = useClientPrincipal();

  const userId = useMemo(() => {
    return process.env.REACT_APP_USE_LOCAL_AUTH === "true"
      ? "test-user-id"
      : clientPrincipal?.userId ?? clientPrincipal?.userDetails;
  }, [clientPrincipal]);

  return userId;
};
